// extracted by mini-css-extract-plugin
export default {"notification_wrap":"Notification_notification_wrap__4MVWD","photo":"Notification_photo__F0-x7","close":"Notification_close__p-NaM"};